import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
// ============================================
// top MV
// ============================================

function sliderHero() {
	const hero01 = document.querySelectorAll('.js-slider-hero');
	if (hero01.length > 0) {
		const myDelay = 10000;

		// アニメーション切り替え
		const switchAnimation = () => {
			let activeSlide = document.querySelectorAll('.js-slider-hero .swiper-slide[class*=-active]');
			for (let i = 0; i < activeSlide.length; i++) {
				activeSlide[i].classList.add('anm-started');
			}
			setTimeout(() => {
				for (let i = 0; i < activeSlide.length; i++) {
					activeSlide[i].classList.remove('anm-started');
				}
			}, myDelay);
		};
		const swiper = new Swiper('.js-slider-hero', {
			loop: true,
			speed: 4000,
			allowTouchMove: false,
			effect: 'fade',
			autoplay: {
				delay: 2000,
			},
			on: {
				slideChangeTransitionStart: () => {
					switchAnimation();
				},
			},
		});
	}
}

// ============================================
//  top case
// ============================================


function sliderCase() {
	const case01 = document.querySelectorAll('.js-slider-case');
	if (case01.length > 0) {
		const swiper = new Swiper('.js-slider-case', {
			speed: 400,
			slidesPerView: 1,
			spaceBetween: 24,
			loop: true,
			navigation: {
				nextEl: '.js-slider__next',
				prevEl: '.js-slider__prev',
			},
			pagination: {
				el: '.js-slider__pagination',
				clickable: true,
			},
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			breakpoints: {
				1024: {
					slidesPerView: 1.23,
					spaceBetween: 100,
				},
			},
		});
	}
}

// ============================================
// export
// ============================================
export { sliderHero , sliderCase };
